import {
    SkyNetTableConfig,
} from 'app/shared-components/SkyNetTable/types/skyNetTable.types'
import {
    FilterType,
} from 'app/enums/common.enums'
import {
    OrderStatuses, OrderTypes, ProductType,
} from 'app/enums/label.enums'

import {
    OutboundOrdersType,
} from '../ScenarioEditor.types'

const config: SkyNetTableConfig<keyof OutboundOrdersType> = {
    name: 'OutboundOrder',
    fields: [
        {
            name: 'orderNumber',
            width: '160px',
            labelKey: 'DailyOpsView.orderNumber',
            componentName: 'OrderTableLink',
        },
        {
            name: 'orderStatus',
            componentName: 'EnumValue',
            allowedValuesEnum: OrderStatuses,
            filterField: 'orderStatus',
            filterType: FilterType.Array,
            labelKey: 'DailyOpsView.orderStatus',
        },
        {
            name: 'orderType',
            componentName: 'EnumValue',
            allowedValuesEnum: OrderTypes,
            labelKey: 'Order.orderType',
            filterField: 'orderType',
            filterType: FilterType.Array,
        },
        {
            name: 'from',
            labelKey: 'OrderBaseTabView.from',
        },
        {
            name: 'to',
            labelKey: 'DailyOpsView.to',
        },
        {
            name: 'customerLocationName',
            filterField: 'customerLocationName',
            filterType: FilterType.Array,
            labelKey: 'Order.customer',
        },
        {
            name: 'pricingAccountCompanyName',
            filterField: 'pricingAccountCompanyName',
            filterType: FilterType.Array,
            labelKey: 'Prebooking.pricingAccount',
        },
        {
            name: 'estimatedPickup',
            sorting: false,
            labelKey: 'OrderStep.estimatedPickup',
        },
        {
            name: 'requiredContainers',
            componentName: 'RequiredContainersList',
            allowedValuesEnum: ProductType,
            sorting: false,
            labelKey: 'Order.requiredContainers',
            filterField: 'requiredContainers',
            filterType: FilterType.Array,
        },
    ],
}

export default config
